/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable */
import ContractApi from "@/api/contract";
import { ContractData } from "@/api/contract/types";
import {
  ContractInfo,
  ContractItem,
  getContractsInfo,
  openContract,
} from "@/ContractConfig";
import { ContractEnum } from "@/enums/contract-type";

export class BaseAgreementData {
  public checked = false;

  protected commodityId = 0;

  protected type: ContractEnum = "" as ContractEnum;

  protected infos: ContractInfo = new ContractInfo();

  public get items(): ContractItem[] {
    return this.infos.items || [];
  }

  public get validated(): boolean {
    return (this.items.length > 0 && this.checked) || this.items.length === 0;
  }

  public init(commodityId: number, type: ContractEnum): void {
    this.commodityId = commodityId;
    this.type = type;
    this.infos = Object.assign(this.infos, new ContractInfo());
    this.checked = false;
  }

  // / 根据 type commodityId 加载参数
  public async reloadNormal(
    data: Dictionary = {},
    isPayOff?: boolean,
    options?: Dictionary
  ): Promise<void> {
    Object.assign(this.infos, getContractsInfo(this.commodityId, this.type));

    // 需要远程请求协议数据
    if (this.infos.isThirdUrl) {
      if (isPayOff) {
        this.infos.items = await this.payContractApi(data);
      } else {
        this.infos.items = await this.api(data, options) as ContractItem[];
      }
    }
  }

  public clickNormal(index: number): void {
    if (this.items[index]) {
      openContract(this.items[index]);
    }
  }

  // 还款展示合同
  protected payContractApi(data: Dictionary = {}): Promise<ContractItem[]> {
    return ContractApi.getPayContractLoan({
      type: this.type,
      commodityId: this.commodityId,
      ...data,
    }) as any;
  }

  protected async api(data: Dictionary = {}, options?: Dictionary): Promise<ContractData[]> {
    return ContractApi.getDynamicUrl({
      type: this.type,
      commodityId: this.commodityId,
      ...data,
    }, options);
  }
}
